




















import { infoStore } from "@/store/infoStore";
import { routerStore } from "@/store/routerStore";
import { pwdManifest } from "@/utils/fileUtils";
import { watch, defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
  setup() {
    const files = computed(() => {
      const manifest = infoStore.getState().manifest;
      const path = routerStore.pwd;
      return pwdManifest(manifest, path);
    });
    return {
      files,
      push: (fileName: string) => {
        routerStore.push(fileName);
      }
    };
  }
});
